var map = {
	"./format-bold.svg": 8755,
	"./format-header-1.svg": 4096,
	"./format-header-2.svg": 5433,
	"./format-header-3.svg": 5239,
	"./format-italic.svg": 2374,
	"./format-list-bulleted.svg": 687,
	"./format-list-numbered.svg": 4226,
	"./format-quote-open.svg": 9241,
	"./format-strikethrough.svg": 4255,
	"./format-underline.svg": 4647,
	"./redo.svg": 8907,
	"./undo.svg": 6177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1610;